/* eslint no-underscore-dangle: 0 */
import moment from "moment";
import { useEffect, useState } from "react";
// import './table.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Alert, Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

const Invoices = () => {
  const [invoices, setInvoices] = useState([])
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // eslint-disable-next-line
    const getInvoicesList = async () => {
      setErrorMessage('');
      try {
        const apiUrl = window.__ENV && window.__ENV.apiUrl;
        const token = localStorage.getItem('token'); // Retrieve the access token from localStorage
        const response = await fetch(`${apiUrl}/api/Invoices`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Request failed with status ', response.status);
        }
        const data = await response.json();
        setInvoices(data.invoices);
        setLoading(false);
      } catch (error) {
        setErrorMessage(error.message);
      }
    };
    getInvoicesList();
  }, []);;

  return (
    <>
      <Card>
        <CardTitle
          tag="h4"
          className="border-bottom px-4 py-3 mb-0 d-flex justify-content-between"
        >
          Invoices
        </CardTitle>
        <CardBody>
          <div style={{ height: "700px", overflow: 'auto', fontSize: '14px' }}>
            <div className="table-responsive">
              {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
              {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Spinner color="primary" size="large" />
                </div>
              ) : (
                 invoices.length === 0 ? (
                  <div>No record found.</div>
                ) : (
                <table className="table table-striped table-hover w-100">
                  <thead>
                    <tr>
                      <th>
                        <strong>DATE</strong>
                      </th>
                      <th>
                        <strong>INVOICE NUMBER</strong>
                      </th>
                      <th>
                        <strong>PO NUMBER</strong>
                      </th>
                      <th>
                        <strong>PO DATE</strong>
                      </th>
                      <th>
                        <strong>CUSTOMER NAME</strong>
                      </th>
                      <th>
                        <strong>INVOICE STATUS</strong>
                      </th>
                      <th>
                        <strong>DUE DATE</strong>
                      </th>
                      <th>
                        <strong>INVOICE AMOUNT</strong>
                      </th>
                    </tr>
                  </thead>
                <tbody>
                  {invoices.map((data) => (
                    <tr key={data.invoice_id}>
                      <td>{data.created_time ? moment(data.created_time).format('DD MMM YYYY') : 'NA'}</td>
                      <td>{data.invoice_number || 'NA'}</td>
                      <td>{data.cf_po_number || 'NA'}</td>
                      <td>{data.cf_po_date || 'NA'}</td>
                      <td>{data.customer_name || 'NA'}</td>
                      <td>{data.due_days || 'NA'}</td>
                      <td>{data.due_date || 'NA'}</td>
                      <td>{data.total || 'NA'}</td>
                      <td>
                        <Link
                          type="button" target="_blank"
                          className="btn btn-sm btn-outline-secondary"
                          to={`/apps/invoices/details/${data.invoice_id}`}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
                 ))}
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default Invoices;

